/**
 * Viewer
 */

import Config from '../Config';
import Util from '../Util';

class Viewer {

	private mobileImgs: string[];

	private originUri: string;

	private mobileImageViewer: any;

	constructor() {

		const win = window as any;

		this.mobileImgs = ['/download_preset/mobile/', '/download_mobile/' ];
		this.originUri = '/download/';

		if ( Config.isMobileSdk || ( win.nc && win.nc.ui && win.nc.ui.ImageViewer ) ) {
			this.addEvent();
		}
	}

	private isEmoticonImage( src: any ) {
		const emoticonUrl = [ '/emoticon', '/emo/' ];

		for ( let item = 0, len = emoticonUrl.length; len > item; item++ ) {
			if ( src.indexOf( emoticonUrl[ item ] ) !== -1 ) {
				return true;
			}
		}

		return false;
	}

	private replaceOrigin( src: any ) {
		for ( let item = 0, len = this.mobileImgs.length; len > item; item++ ) {
			src = src.replace( this.mobileImgs[ item ], this.originUri );
		}
		return src;
	}

	private popView( src: any ) {
		if ( this.isEmoticonImage( src ) ) {
			return;
		}

		const arr: any = [];
		const win = window as any;

		jQuery( '.fe-image:not(".gdict_contents>.fe-image"), .editorAttachedImage' ).each( ( itemIdx, item ) => {

			let _src = jQuery( item ).attr( 'src' );

			for ( let idx = 0, len = this.mobileImgs.length; len > idx; idx++ ) {
				if ( _src.indexOf( this.mobileImgs[ idx ] ) !== -1 ) {
					_src = this.replaceOrigin( _src );
				}
			}

			if ( !this.isEmoticonImage( _src ) ) {
				arr.push( _src );
			}
		});

		src = this.replaceOrigin( src );

		if ( Config.isMobileSdk || Config.isBnsApp ) {
			const title = jQuery( '.view-header .view-title' ).text();
			const content = '';
			const cursor = arr.indexOf( src );
			location.href = ( Config.isMobileSdk ) ?
				`${ Config.mobileSdk.viewer( cursor ) }` :
				`${ Config.app.viewer }?title=${title}&content=${content}&images=${arr.toString()}&cursor=${cursor}`;
			return;
		}

		if ( !this.mobileImageViewer ) {
			if ( win.nc && win.nc.ui && win.nc.ui.ImageViewer ) {
				this.mobileImageViewer = new win.nc.ui.ImageViewer( jQuery( 'body' ), arr, {commentUrl: ''} );
			}
		}

		this.mobileImageViewer.slideByUrl( src );
	}

	private addEvent() {
		jQuery( 'body' ).on( 'click', '.fe-image, .editorAttachedImage', ( evt ) => {
			evt.preventDefault();
			this.popView( jQuery( evt.currentTarget ).attr( 'src' ) );
		});
	}
}

export default Viewer;
